import React, { ReactElement } from 'react';

import { css } from '@emotion/css';

import { Card, CardHeader } from 'components/Card';

import { CardLoader } from '../shared/CardLoader';

export type MetricsCardProps = {};

export const MetricsCard = ({
  title,
  headerActions,
  description,
  loading,
  children,
}: {
  title: string;
  headerActions?: ReactElement;
  description: string;
  loading: boolean;
  children: JSX.Element;
}) => (
  <Card
    className={css`
      width: 100%;
    `}
  >
    <CardHeader title={title} useTooltip description={description} headerActions={headerActions} />
    <div
      className={css`
        height: 100%;
        width: 100%;
        padding: 8px;
      `}
    >
      {loading ? (
        <div
          className={css`
            height: 300px;
            width: 100%;
          `}
        >
          <CardLoader height={500} />
        </div>
      ) : (
        children
      )}
    </div>
  </Card>
);
